import styled from 'styled-components';

const CenteredText = styled.div`
  text-align: center;
`;

export default CenteredText;



// WEBPACK FOOTER //
// ./src/styled/CenteredText.js